<template>
  <div class="input-wrapper">
    <div class="label">{{ isFocus || value ? label : "" }}</div>
    <input
      :type="type"
      :value="value"
      :disabled="disabled"
      @keydown="validate($event)"
      @paste="onPaste($event)"
      @input="$emit('input', $event.target.value)"
      @focus="isFocus = true"
      @blur="isFocus = false"
      :placeholder="!isFocus ? placeholder : ''"
    />
    <p class="error" v-if="error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },

    error: {
      type: String,
      default: null
    },

    required: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: "text"
    }
  },

  data() {
    return {
      isFocus: false
    };
  },

  methods: {
    validate(event) {
      if (
        (this.type === "number" || this.type === "tel") &&
        !this.isNumber(event)
      ) {
        event.preventDefault();
        return false;
      }

      return true;
    },

    onPaste(event) {
      if (this.type === "Number" || this.type === "tel") {
        event.preventDefault();
        return false;
      }
    },

    isNumber(e) {
      if (e.keyCode === 32) return false;
      let key = Number(e.key);
      return !(isNaN(key) || e.key === null) || e.keyCode === 8;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
  padding: 20px 0 10px 0;

  .label {
    color: #5a5a65;
    font-family: $Quicksand;
    font-size: 14px;
    position: absolute;
    top: 0;
    left: 0;
  }

  input {
    width: 100%;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #a7a7a7;
    font-size: 18px;
    color: #7f908c;

    &:focus {
      border-color: $color4;
    }

    &:disabled {
      background-color: #fff;
      opacity: 0.5;
    }
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
  /* Webkit browsers like Safari and Chrome */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .error {
    color: $color7;
    font-size: 12px;
    margin-top: 2px;
  }
}
</style>
